import React from 'react';
import { Link } from 'react-router-dom';
import Badges from '../Widgets/Badges';

export default () => (
    <div id="statistics-matches">
        <header className="content-header">
            <h1>
                Statistics
                <small>Various</small>
            </h1>
            <ol className="breadcrumb">
                <li><i className="fa fa-bar-chart"/> Statistics</li>
                <li className="text-bold"><Link to="/statistics/various">Various</Link></li>
            </ol>
        </header>
        <section className="content">
            <Badges />
        </section>
    </div>
);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Various/index.js